import React from "react";
import styles from './index.module.css';

const Footer = () => {
    return (
      <footer className={styles.footer}>
           <div>
            Copyright © {new Date().getFullYear()}{" "} IBSU 
          </div>
      </footer>
    );
  };
  
  export default Footer;